import { createClient } from '@/shared/api';
import type {
  UpdateStudyPatientContactMutation,
  UpdateStudyPatientContactMutationVariables,
} from '@/shared/api';
import UPDATE_STUDY_PATIENT_CONTACT from '../mutations/updateStudyPatientContact';

/**
 * Saves the patient's primary contact details on a study. Runs UPDATE_STUDY_PATIENT_CONTACT and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns The updateStudyPatientContact payload.
 */
const handleUpdateStudyPatientContact = async (
  input: UpdateStudyPatientContactMutationVariables['input'],
): Promise<UpdateStudyPatientContactMutation['updateStudyPatientContact']> => {
  const client = createClient();
  const result = await client.mutate<
    UpdateStudyPatientContactMutation,
    UpdateStudyPatientContactMutationVariables
  >({
    mutation: UPDATE_STUDY_PATIENT_CONTACT,
    variables: { input },
  });
  const { data } = result;
  const { updateStudyPatientContact } = data ?? {};
  if (!updateStudyPatientContact?.isSuccess) {
    throw new Error(updateStudyPatientContact?.message ?? undefined);
  }
  return updateStudyPatientContact;
};

export default handleUpdateStudyPatientContact;
